import { useEffect } from "react";

const SITE = "Incolour Films";
const DEFAULT_DESC =
  "Incolour Films — original films, commercials, PSAs, and music videos made in Toronto & the GTA. Think Incolour.";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, image, imageAlt, path, type = "website", noindex = false, jsonLd = null }) {
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const origin = "https://incolourfilms.ca";
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Toronto Film Production Company`;
    const desc = description || DEFAULT_DESC;
    const img = image || `${origin}/og-default.png`;
    const imgAlt = imageAlt || fullTitle;
    const url = `${origin}${path || window.location.pathname}`;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertMeta("property", "og:site_name", SITE);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:image:alt", imgAlt);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", img);
    upsertMeta("name", "twitter:image:alt", imgAlt);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    let script = null;
    if (jsonLdString) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.textContent = jsonLdString;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, image, imageAlt, path, type, noindex, jsonLdString]);

  return null;
}
